export default __webpack_public_path__ + "static/media/UiStats.3f76b2e5.svg";